import utils from '../utils'
import ZjLayoutContainer from './src/container.vue'
import ZjLayoutHeader from './src/header.vue'
import ZjLayoutMain from './src/main.vue'
import ZjLayoutFooter from './src/footer.vue'
import ZjLngLatSelect from './src/lnglatselect.vue'
import CameraPreview from './src/CameraPreview.vue'
import CameraPlayback from './src/CameraPlayback.vue'
import ElaryWarningBox from './src/ElaryWarningBox.vue'//预警弹窗提醒
import ZjDialog from './src/dialog.vue'
import Communicate from './src/Communicate.vue'//通话弹窗提醒
import WarningNotification from './src/WarningNotification.vue'//预警通知
import DoubleLineEchart from './src/echarts/DoubleLineEchart.vue'//双折现图
import RingPieEchart from './src/echarts/RingPieEchart.vue'//环形图
import LineEchart from './src/echarts/LineEchart.vue'//折线图
import BarEchart from './src/echarts/BarEchart.vue'//环形图


const cmps = {
    ZjLayoutContainer,
    ZjLayoutHeader,
    ZjLayoutMain,
    ZjLayoutFooter,
    ZjLngLatSelect,
    CameraPreview,
    CameraPlayback,
    ElaryWarningBox,
    ZjDialog,
    Communicate,
    WarningNotification,
    DoubleLineEchart,
    RingPieEchart,
    LineEchart,
    BarEchart
}

const install = function (Vue) {
    utils.each(cmps, cmp => Vue.component(cmp.name, cmp))
}

export default {
    install,
    ...cmps
}